module.exports = __webpack_public_path__ + "img/salvation.be0d1b5d.webp";